angular.module('lf.desktop')

.controller('CheckoutCtrl', function ($scope, $rootScope, slideinService, checkoutService, preloadData, gtmService) {
  
  /**
   * Check if user is logged in (account or guest)
   */
  
  $scope.isUserLoggedIn = function () {
    return lf.data && lf.data.xhr && lf.data.xhr.user.emailAddress;
  }
  
  /* 
	 * Get Saved Creditcards - 
	 * This function is used to get saved creditcards in current ATG Profile
	 */
	$scope.getSavedCreditcards = function($event) {
		checkoutService.getSavedCreditcards({})
		.success(function(getSavedCreditcardsResponse) {
			console.log("Successfully received saved creditcards.");
		});
	}
	
	/* 
	 * Get Saved Addresses - 
	 * This function is used to get saved addresses in current ATG Profile
	 */
	$scope.getSavedAddresses = function($event) {
		checkoutService.getSavedAddresses({})
		.success(function(getSavedAddressesResponse) {
			console.log("Successfully received saved addresses.");
		});
	}
	
	/*
	 * Dummy Edit Shipping Address Form
	 */
	var editShippingAddressForm = { 
			firstName: "firstName",
			lastName: "lastName",
			address1: "6401 Hollis St",
			address2: "",
			city: "Emeryville",
			state: "CA",
			country: "US",
			postalCode: "94568",
			phoneNumber: "1111111111",
			addressId: "16860084",
			addressNickName: "426442470"
	};
	
	/* Data structure to hold experian suggestions returned during 
	 * Add New Shipping Address and Edit Shipping Address
	 */
	$scope.experianResponseData = {};
	
	/* 
	 * Edit Address ::
	 * This is a private function that is used in both steps of Edit Address
	 * Step 1 - when user submits the updated address and
	 * Step 2 - when user responds to the suggestions received from Experian by 
	 * either accepting one of the suggestions or rejecting
	 */
	function editShippingAddress($event, paramsObj) {
		checkoutService.
		  	editShippingAddress(paramsObj)
		  		.success(function (editShippingAddressResponse) {
			  
		  			if (!editShippingAddressResponse.data.success) {
		  	      		if(typeof editShippingAddressResponse.data.passed != 'undefined' && !editShippingAddressResponse.data.passed) {
		  	      			// editShippingAddressResponse.data.passed = false :: we have some suggestions.. show these suggestions to the user.
		  	      			console.log("Address verification service returned with some suggestions.");
		  	      			$scope.experianResponseData = editShippingAddressResponse.data;
		  	      			/* Output Structure 
		  	      			   {
		  	      			 		success: false, 
		  	      			    	error : {code: "", message: ""}, 
		  	      			    	passed: false, 
		  	      			    	response : {
		  	    						"error": "PremisesPartial",
		  	    						"message": "Please confirm your Apt/Ste/Unit Number",
		  	    						"suggestions": {
		  	    							"count": 4,
		  									"data": [{ .... }]
		  	    						}
		  	    					},
		  	    					testedAddress: { .... }
		  	    				}
		  	    			*/
		  	      			
		  	      			// Test Case # 1 :: User Selects An Address From Experian Suggestions
		  	      			//testCaseUserSelectsAnAddressFromExperianSuggestions(false);
		  	      			
		  	      			// Test Case # 2 :: User Decided To Ignore Experian Suggestions and Keep The User Entered Address
		  	      			//testCaseUserDecidedToKeepTheUserEnteredAddress(paramsObj, false);
			  	      	} else {
		  	      			// editShippingAddressResponse.data.success = false :: general error has occurred.
		  	      			console.log("Address verification failed with a general error.");
		  	      			// Not sure if this case will ever happen.
		  	      			// Output structure: {success: false, error : {code: "", message: ""}}
		  	      		}
		  	      		
		  	      	} else {
		  	      		if(editShippingAddressResponse.data.addressId == "") {
		  	      			// this was a duplicate address. we might need to show a proper error message
		  	      			console.log("Duplicate address!");
		  	      		} else {
		  		      		// address was added successfully. 
		  		      		console.log("Address was updated successfully.");
		  	      		}
		  	      	}
		  		});
	}
	
	/* 
	 * Edit Address :: Step 1 - 
	 * This function will be called when user submits edit address form
	 */
	$scope.editShippingAddressStep1 = function($event) {
		var paramsObj = {};
		paramsObj["firstName"] = editShippingAddressForm.firstName;
    	paramsObj["lastName"] = editShippingAddressForm.lastName;
    	paramsObj["address1"] = editShippingAddressForm.address1;
    	paramsObj["address2"] = editShippingAddressForm.address2;
    	paramsObj["city"] = editShippingAddressForm.city;
    	paramsObj["state"] = editShippingAddressForm.state;
    	paramsObj["country"] = editShippingAddressForm.country;
    	paramsObj["postalCode"] = editShippingAddressForm.postalCode;
    	paramsObj["phoneNumber"] = editShippingAddressForm.phoneNumber;
    	paramsObj["addressId"] = editShippingAddressForm.addressId;
    	paramsObj["addressNickName"] = editShippingAddressForm.addressNickName;
    	paramsObj["verifyAddress"] = true;
    	editShippingAddress($event, paramsObj);
	}
	
	/* 
	 * Edit Address :: Step 2 - 
	 * This function will be called when user chooses to keep user entered address and 
	 * ignore suggestions provided by experian 
	 */
	$scope.keepUserEnteredAddressForEditAddress = function($event) {
		console.log('User decided to keep the address as entered is and ignore experian suggestions.');
		var paramsObj = {};
    	paramsObj["firstName"] = editShippingAddressForm.firstName;
    	paramsObj["lastName"] = editShippingAddressForm.lastName;
    	paramsObj["address1"] = editShippingAddressForm.address1;
    	paramsObj["address2"] = editShippingAddressForm.address2;
    	paramsObj["city"] = editShippingAddressForm.city;
    	paramsObj["state"] = editShippingAddressForm.state;
    	paramsObj["country"] = editShippingAddressForm.country;
    	paramsObj["postalCode"] = editShippingAddressForm.postalCode;
    	paramsObj["phoneNumber"] = editShippingAddressForm.phoneNumber;
    	paramsObj["addressId"] = editShippingAddressForm.addressId;
    	paramsObj["addressNickName"] = editShippingAddressForm.addressNickName;
    	paramsObj["verifyAddress"] = false;
    	paramsObj["optionOpted"] = "userEnteredAddress";
    	editShippingAddress($event, paramsObj);
	}
	
	/* 
	 * Edit Address :: Step 2 - 
	 * This function will be called when user chooses one of the suggestions
	 * provided by experian 
	 */
	$scope.selectExperianSuggestionForEditAddress = function($event, index) {
		console.log('User decided to select an address ('+$scope.experianResponseData.response.suggestions.data[index].address.street1+') from the experian suggestions.');
		var paramsObj = {};
      	paramsObj["firstName"] = editShippingAddressForm.firstName;
      	paramsObj["lastName"] = editShippingAddressForm.lastName;
      	paramsObj["address1"] = $scope.experianResponseData.response.suggestions.data[index].address.street1;
      	paramsObj["address2"] = $scope.experianResponseData.response.suggestions.data[index].address.street2;
      	paramsObj["city"] = $scope.experianResponseData.response.suggestions.data[index].address.city;
      	paramsObj["state"] = $scope.experianResponseData.response.suggestions.data[index].address.state;
      	paramsObj["country"] = editShippingAddressForm.country;
      	paramsObj["postalCode"] = $scope.experianResponseData.response.suggestions.data[index].address.zip;
      	paramsObj["phoneNumber"] = editShippingAddressForm.phoneNumber;
      	paramsObj["addressId"] = editShippingAddressForm.addressId;
      	paramsObj["addressNickName"] = editShippingAddressForm.addressNickName;
      	// Note:: We don't need to do address verification for this address.
      	paramsObj["verifyAddress"] = false;
      	paramsObj["optionOpted"] = "selectExperianSuggestion";
      	editShippingAddress($event, paramsObj);
	}
	
	// Update Address Test Case # 1 :: User Selects An Address From Experian Suggestions
	function testCaseUserSelectsAnAddressFromExperianSuggestions(isAddNewAddressMode) {
		if(isAddNewAddressMode) {
			$scope.selectExperianSuggestionForAddNewShippingAddress(null, 0);
		} else {
			$scope.selectExperianSuggestionForEditAddress(null, 0);
		}
	}
	
	// Update Address Test Case # 2 :: User Decided To Ignore Experian Suggestions and Keep The User Entered Address
	function testCaseUserDecidedToKeepTheUserEnteredAddress(paramsObj, isAddNewAddressMode) {
		if(isAddNewAddressMode) {
			$scope.keepUserEnteredAddressForAddNewShippingAddress(null);
		} else {
			$scope.keepUserEnteredAddressForEditAddress(null);
		}
	}
	
	
	/* 
	 * Add New Shipping Address ::  
	 * This is a private function that is used in both steps of Add New Address
	 * Step 1 - when user submits a new shipping address and
	 * Step 2 - when user responds to the suggestions received from Experian by 
	 * either accepting one of the suggestions or by rejecting
	 */
	function addNewShippingAddress ($event, paramsObj) {
		checkoutService.addNewShippingAddress(paramsObj)
	  		.success(function (addNewShippingAddressResponse) {
	      
		      	if (!addNewShippingAddressResponse.data.success) {
		      		if(typeof addNewShippingAddressResponse.data.passed != 'undefined' && !addNewShippingAddressResponse.data.passed) {
		      			// addNewShippingAddressResponse.data.passed = false :: we have some suggestions.. show these suggestions to the user.
		      			console.log("Address verification service returned with some suggestions.");
		      			$scope.experianResponseData = addNewShippingAddressResponse.data;
		      			/* Output Structure 
		     			   {
		     			 		success: false, 
		     			    	error : {code: "", message: ""}, 
		     			    	passed: false, 
		     			    	response : {
		   						"error": "PremisesPartial",
		   						"message": "Please confirm your Apt/Ste/Unit Number",
		   						"suggestions": {
		   							"count": 4,
										"data": [{ .... }]
		   						}
		   					},
		   					testedAddress: { .... }
		   				}
		   			*/
		     			
		     			// Test Case # 1 :: User Selects An Address From Experian Suggestions
		     			//testCaseUserSelectsAnAddressFromExperianSuggestions(true);
		     			
		     			// Test Case # 2 :: User Decided To Ignore Experian Suggestions and Keep The User Entered Address
		     			//testCaseUserDecidedToKeepTheUserEnteredAddress(paramsObj, true);
		      		} else {
		      			// addNewShippingAddressResponse.data.success = false :: general error has occurred.
		      			console.log("Address verification failed with a general error.");
		      			// Not sure if this case will ever happen.
		      			// Output structure: {success: false, error : {code: "", message: ""}}
		      			
		      		}
		      		
		      	} else {
		      		if(addNewShippingAddressResponse.data.addressId == "") {
		      			// this was a duplicate address. we might need to show a proper error message
		      			console.log("Duplicate address!");
		      		} else {
			      		// address was added successfully. 
			      		console.log("Address was verified and added successfully.");
			      		
			      		// Get shipping methods for this address.
			      		/*checkoutService.getShippingOptions({
					        	address1: $scope.addressForm.street1,
					        	state: $scope.addressForm.state,
					        	country: $scope.addressForm.country,
					        	zipCode: $scope.addressForm.postalCode,
					        	isCartZipCode: false
					        })*/
					    checkoutService.getShippingOptions({
					        	address1: addNewShippingAddressForm.address1,
					        	state: addNewShippingAddressForm.state,
					        	country: addNewShippingAddressForm.country,
					        	zipCode: addNewShippingAddressForm.postalCode,
					        	isCartZipCode: false
					        })
					        .success(function (getShippingOptionsResponse) {
					        	// Show these shipping methods to the user and auto select the default shipping method
					        	var returnedShippingMethodsCount = 0;
					        	if(typeof getShippingOptionsResponse.shippingMethods != 'undefined') {
					        		returnedShippingMethodsCount = getShippingOptionsResponse.shippingMethods.length;
					        	}
					        	console.log("Returned "+ returnedShippingMethodsCount +" shipping methods for this address");
					        	/*
					        	{
					        		"shippingMethods": [{
					        			"shippingAmount": "$5.25",
					        			"shippingAmountRaw": 5.25,
					        			"shippingMethodName": "Ground",
					        			"shippingDescription": "",
					        			"selected": "true",
					        			"deliveryInformation": "&nbsp;Dec&nbsp;15-19"
					        		}, {
					        			"shippingAmount": "$12.70",
					        			"shippingAmountRaw": 12.7,
					        			"shippingMethodName": "2nd Day Air",
					        			"shippingDescription": "",
					        			"selected": "false",
					        			"deliveryInformation": "&nbsp;Dec&nbsp;12-15"
					        		}, {
					        			"shippingAmount": "$21.83",
					        			"shippingAmountRaw": 21.83,
					        			"shippingMethodName": "Next Day Air",
					        			"shippingDescription": "",
					        			"selected": "false",
					        			"deliveryInformation": "&nbsp;Dec&nbsp;11-12"
					        		}]
					        	}
					        	*/
					        	
					        	if(returnedShippingMethodsCount > 0) {
					        		// select first shipping method. 
					        		checkoutService.applyShippingInformation({
					        			shippingMethodName: getShippingOptionsResponse.shippingMethods[0].shippingMethodName,
					        			shippingAddressId: addNewShippingAddressResponse.data.addressId,
					        			address1: addNewShippingAddressForm.address1, 
					        			address2: addNewShippingAddressForm.address2,
					        			city: addNewShippingAddressForm.city,
					        			state: addNewShippingAddressForm.state,
					        			country: addNewShippingAddressForm.country,
					        			postalCode: addNewShippingAddressForm.postalCode,
					        			verificationStatus: "VERIFIED"
					        		})
					        		.success(function (applyShippingMethodResponse) {
							        	// get updated order data
							        	console.log("Shipping method '"+getShippingOptionsResponse.shippingMethods[0].shippingMethodName +"' was applied to the order successfully.");
							        	
							        	checkoutService.getOrderData()
							        		.success(function (getOrderDataResponse) {
							        			console.log("Got order data.");
							        			/* Same structure as: lf.data.xhr.shop
							        			{
													"accountBalance": {
														"val": 585,
														"fmt": "$585.00"
													},
													"softgoodsCart": {
														"pricing": {
															"subTotal": {
																"val": 0,
																"fmt": "$0.00"
															}
														},
														"items": []
													},
													"hardgoodsCart": {
														"pricing": {
															"discountedAmount": {
																"val": "-0.0",
																"fmt": "-$0.00"
															},
															"subTotalWithoutDiscount": {
																"val": 99.99,
																"fmt": "$99.99"
															},
															"subTotal": {
																"val": 99.99,
																"fmt": "$99.99"
															},
															"shippingAmount": {
																"val": 5.25,
																"fmt": "$5.25"
															},
															"orderTax": {
																"val": 0,
																"fmt": "$0.00"
															},
															"orderTotalWithoutTax": {
																"val": 105.24,
																"fmt": "$105.24"
															},
															"youSavedAmount": {
																"val": 0,
																"fmt": "$0.00"
															},
															"orderTotal": {
																"val": 105.24,
																"fmt": "$105.24"
															},
															"orderTotalWithoutShipping": {
																"val": 99.99,
																"fmt": "$99.99"
															},
															"applicableAccountBalance": {
																"val": 0,
																"fmt": "$0.00"
															},
															"shippingPromoAmount": {
																"val": "",
																"fmt": "$0.00"
															},
															"promoDescription": "",
															"shippingPromoDescription": "",
															"promos": {
																"qualifiers": [],
																"applied": []
															},
															"commitOrder": {}
														},
														"items": [{
															"cartItemId": "ciu381000002",
															"quantity": 1,
															"id": "prod31500",
															"skuId": "31500",
															"type": "hardgoods",
															"siteId": "usw",
															"siteBaseUrl": "/en-us/store",
															"title": "LeapPad3 Learning Tablet, Green",
															"reportingTitle": "LeapPad3 Learning Tablet",
															"productUrl": "/en-us/store/p/leappad3/_/A-prod31500",
															"thumb": {
																"src": "//s7.leapfrog.com/is/image/LeapFrog/31500?$checkout-icon$",
																"alt": "LeapPad Learning Tablet, Green"
															},
															"miniThumb": {
																"src": "//s7.leapfrog.com/is/image/LeapFrog/31500?$detail-sm-png$",
																"alt": "LeapPad Learning Tablet, Green"
															},
															"colorSwatch": {
																"src": "//s7.leapfrog.com/is/image/LeapFrog/swatch_green?$swatch_cart$"
															},
															"pricing": {
																"onSale": false,
																"list": {
																	"val": 99.99,
																	"fmt": "$99.99"
																},
																"itemTotal": {
																	"val": 99.99,
																	"fmt": "$99.99"
																},
																"promos": []
															}
														}]
													},
													"wishlist": {
														"items": []
													}
												}
							        			 */
							        		}); // end checkoutService.getOrderData.success
							        }); // end checkoutService.applyShippingInformation
					        	}
					        }); // end checkoutService.getShippingOptions
		      			}
	      		}
      }); // checkoutService.addNewShippingAddress(paramsObj)
	}
	
	/*
	 * Dummy Add New Shipping Address Form
	 */
	var addNewShippingAddressForm = { 
			firstName: "la",
			lastName: "la",
			address1: "5700 Johnston St",
			address2: "",
			city: "Lafayette",
			state: "LA",
			country: "US",
			postalCode: "70503-5312",
			phoneNumber: "1111111111",
			setAsDefaultAddress: true
	};
	
	/* 
	 * Add New Shipping Address :: Step 1 - 
	 * This function will be called when user submits a new address form
	 */
	$scope.addNewShippingAddressStep1 = function($event) {
		var paramsObj = {};
		paramsObj["firstName"] = addNewShippingAddressForm.firstName;
    	paramsObj["lastName"] = addNewShippingAddressForm.lastName;
    	paramsObj["address1"] = addNewShippingAddressForm.address1;
    	paramsObj["address2"] = addNewShippingAddressForm.address2;
    	paramsObj["city"] = addNewShippingAddressForm.city;
    	paramsObj["state"] = addNewShippingAddressForm.state;
    	paramsObj["country"] = addNewShippingAddressForm.country;
    	paramsObj["postalCode"] = addNewShippingAddressForm.postalCode;
    	paramsObj["phoneNumber"] = addNewShippingAddressForm.phoneNumber;
    	paramsObj["setAsDefaultAddress"] = addNewShippingAddressForm.setAsDefaultAddress;
    	paramsObj["verifyAddress"] = true;
    	
    	/* optionOpted is passed only when the user is responding to the experian suggestions
    	optionOpted = "userAddress" => if user decided to ignore the suggestions and use the user entered address anyway 
   	    optionOpted = "InteractionRequired" ?? Not sure if this is applicable in this flow?
   	    optionOpted = "Verified" ?? Not sure if this is applicable in this flow?
   	    optionOpted = "PremisesPartial" => if the user selected one of the addresses from suggestions
   	    */
    	//paramsObj["optionOpted"] = "InteractionRequired"; // $scope.addressForm.optionOpted
    	addNewShippingAddress($event, paramsObj);
	};
	
	/* 
	 * Add New Shipping Address :: Step 2 - 
	 * This function will be called when user chooses to keep user entered address and 
	 * ignore suggestions provided by experian 
	 */
	$scope.keepUserEnteredAddressForAddNewShippingAddress = function($event) {
		console.log('User decided to keep the address as entered is and ignore experian suggestions.');
		var paramsObj = {};
    	paramsObj["firstName"] = addNewShippingAddressForm.firstName;
    	paramsObj["lastName"] = addNewShippingAddressForm.lastName;
    	paramsObj["address1"] = addNewShippingAddressForm.address1;
    	paramsObj["address2"] = addNewShippingAddressForm.address2;
    	paramsObj["city"] = addNewShippingAddressForm.city;
    	paramsObj["state"] = addNewShippingAddressForm.state;
    	paramsObj["country"] = addNewShippingAddressForm.country;
    	paramsObj["postalCode"] = addNewShippingAddressForm.postalCode;
    	paramsObj["phoneNumber"] = addNewShippingAddressForm.phoneNumber;
    	paramsObj["verifyAddress"] = false;
    	paramsObj["optionOpted"] = "userEnteredAddress";
    	addNewShippingAddress($event, paramsObj);
	}
	
	/* 
	 * Add New Shipping Address :: Step 2 - 
	 * This function will be called when user chooses one of the suggestions
	 * provided by experian 
	 */
	$scope.selectExperianSuggestionForAddNewShippingAddress = function($event, index) {
		console.log('User decided to select an address ('+$scope.experianResponseData.response.suggestions.data[index].address.street1+') from the experian suggestions.');
		var paramsObj = {};
      	paramsObj["firstName"] = addNewShippingAddressForm.firstName;
      	paramsObj["lastName"] = addNewShippingAddressForm.lastName;
      	paramsObj["address1"] = $scope.experianResponseData.response.suggestions.data[index].address.street1;
      	paramsObj["address2"] = $scope.experianResponseData.response.suggestions.data[index].address.street2;
      	paramsObj["city"] = $scope.experianResponseData.response.suggestions.data[index].address.city;
      	paramsObj["state"] = $scope.experianResponseData.response.suggestions.data[index].address.state;
      	paramsObj["country"] = addNewShippingAddressForm.country;
      	paramsObj["postalCode"] = $scope.experianResponseData.response.suggestions.data[index].address.zip;
      	paramsObj["phoneNumber"] = addNewShippingAddressForm.phoneNumber;
      	// Note:: We don't need to do address verification for this address.
      	paramsObj["verifyAddress"] = false;
      	paramsObj["optionOpted"] = "selectExperianSuggestion";
      	addNewShippingAddress($event, paramsObj);
	}
});
